import { User } from "../Application/user";
import i18n from "../../i18n";

export interface SupplierColumn {
  id: "name" | "contact" | "tinNumber" | "action";
  label: string;
  minWidth?: number;
  align?: "center";
}

export const supplierColumns: SupplierColumn[] = [
  { id: "name", label: i18n.t("name"), align: "center" },
  { id: "contact", label: i18n.t("contact"), align: "center" },
  { id: "tinNumber", label: i18n.t("tinNumber"), align: "center" },
  { id: "action", label: i18n.t("action"), align: "center" },
];

export interface SupplierRow {
  name: string;
  contact: string;
  tinNumber: number;
  action: any;
}

export interface Supplier {
  _id: string;
  name: string;
  address: string;
  contact: string;
  email: string;
  website: string;
  tinNumber: number;
  supplies: string;
  createdBy?: User;
  createdAt: string;
  updatedAt: string;
}
